/* globals _ */

import Location from './location';

const { extend } = _;

export default Location.extend( {
	key: 'venue',

	defaults: extend( Location.prototype.defaults, {
		description: '',
		website: '',
		date: '',
		time: '',
		endDate: '',
		endTime: '',
		isEvent: 0,
		isRecurring: 0,
	} ),

	bindCategory: function() {
		return [
			'change:category',
			( $elm, options ) => {
				var category = this.getAttributeObject( 'category' );
				if ( options.use === 'icon' ) {
					if ( category ) {
						$elm.attr( 'data-category', category.get( 'slug' ) );
					}
					return;
				}
				return category.get( 'name' );
			},
		];
	},

	bindWebsite: function() {
		return [
			'change:website',
			( $elm ) => {
				var website = this.get( 'website' );

				$elm.toggle( website !== '' );
				$elm.attr( 'href', website );
			},
		];
	},

	matchSearch: function( query ) {
		query = query.toLowerCase().split( ' ' );

		var name = this.get( 'name' ).toLowerCase(),
			desc = this.get( 'description' ).toLowerCase(),
			addr = this.get( 'address' ).toLowerCase(),
			tags = ( this.get( 'keywords' ) || '' ).trim().split( /#/ ).map( tag => tag.trim().toLowerCase() );

		var score = 0;

		query.forEach( term => {
			if ( tags.indexOf( term ) >= 0 ) {
				score += 8;
			}
			if ( name.indexOf( term ) >= 0 ) {
				score += 4;
			}
			if ( desc.indexOf( term ) >= 0 ) {
				score += 2;
			}
			if ( addr.indexOf( term ) >= 0 ) {
				score += 1;
			}
		} );

		this.set( 'searhScore', score );

		return score;
	},
} );
